import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Google Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Google Sans, sans-serif',
    },
    h2: {
      fontFamily: 'Google Sans, sans-serif',
    },
    h3: {
      fontFamily: 'Google Sans, sans-serif',
    },
    h4: {
      fontFamily: 'Google Sans, sans-serif',
    },
    h5: {
      fontFamily: 'Google Sans, sans-serif',
    },
    h6: {
      fontFamily: 'Google Sans, sans-serif',
    },
    body1: {
      fontFamily: 'Google Sans, sans-serif',
    },
    body2: {
      fontFamily: 'Google Sans, sans-serif',
    },
    button: {
      fontFamily: 'Google Sans, sans-serif',
    },
    caption: {
      fontFamily: 'Google Sans, sans-serif',
    },
    overline: {
      fontFamily: 'Google Sans, sans-serif',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Google Sans, sans-serif',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Google Sans, sans-serif',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: 'Google Sans, sans-serif',
          '& .MuiInputBase-input': {
            fontFamily: 'Google Sans, sans-serif',
          },
          '& .MuiInputLabel-root': {
            fontFamily: 'Google Sans, sans-serif',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Google Sans, sans-serif',
        },
      },
    },
  },
});

export default theme;
